var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrashCan = function SvgTrashCan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "trash-can_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8.992v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-10h2v10a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4v-10h2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.992a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.992v-1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h3a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h3zm2-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4v-1z",
    fill: "currentColor"
  })));
};

export { SvgTrashCan as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcgOC45OTJ2MTBhMiAyIDAgMDAyIDJoNmEyIDIgMCAwMDItMnYtMTBoMnYxMGE0IDQgMCAwMS00IDRIOWE0IDQgMCAwMS00LTR2LTEwaDJ6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTAgMTEuOTkyYTEgMSAwIDAwLTEgMXY0YTEgMSAwIDEwMiAwdi00YTEgMSAwIDAwLTEtMXptNCAwYTEgMSAwIDAwLTEgMXY0YTEgMSAwIDEwMiAwdi00YTEgMSAwIDAwLTEtMXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCA2Ljk5MnYtMWEzIDMgMCAwMTMtM2gyYTMgMyAwIDAxMyAzdjFoM2ExIDEgMCAxMTAgMkg1YTEgMSAwIDExMC0yaDN6bTItMWExIDEgMCAwMTEtMWgyYTEgMSAwIDAxMSAxdjFoLTR2LTF6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";